import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@material-ui/core";

import { ConfirmGenerateTicketsDialogProps } from "../../../interface/dialog/ConfirmGenerateTicketsDialogProps";
import Button from "../Button";
import { useDialogStyles } from "./styles";
import { bPrefix, formatTicketNumber } from "../../../utils/parser";

// Replaces a window.confirm. Generating is not reversible from the UI, and the ranges
// involved are large enough that a slipped digit is easy to miss.
const ConfirmGenerateTicketsDialog = ({
  open,
  from,
  to,
  isBSeries,
  onClose,
  onConfirm,
}: ConfirmGenerateTicketsDialogProps) => {
  const classes = useDialogStyles();
  const count = to - from + 1;
  const prefix = bPrefix({ isBSeries });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle className={classes.dialogTitle}>
        Confirm Ticket Generation
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <div className={classes.stackedContent}>
          <Typography>
            <b>{count.toLocaleString()}</b> tickets will be generated, numbered{" "}
            <b>
              {prefix}
              {formatTicketNumber(from)}
            </b>{" "}
            to{" "}
            <b>
              {prefix}
              {formatTicketNumber(to)}
            </b>
            .
          </Typography>
          <Typography className={classes.helperText}>
            Generated tickets cannot be removed from this screen. Check the
            range before continuing.
          </Typography>
        </div>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <div className={classes.actionButton}>
          <Button
            label="Cancel"
            onClick={onClose}
            color="default"
            variant="contained"
            type="button"
          />
        </div>
        <div className={classes.actionButton}>
          <Button
            label="Generate"
            onClick={onConfirm}
            autoFocus
            color="primary"
            variant="contained"
            type="button"
          />
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmGenerateTicketsDialog;
